import { render, staticRenderFns } from "./c-blister.vue?vue&type=template&id=140d742c&scoped=true&"
import script from "./c-blister.vue?vue&type=script&lang=js&"
export * from "./c-blister.vue?vue&type=script&lang=js&"
import style0 from "./c-blister.vue?vue&type=style&index=0&id=140d742c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d742c",
  null
  
)

export default component.exports